var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/birthday_input.tsx";
import React, { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import IconButton from 'soapbox/components/icon_button';
import BundleContainer from 'soapbox/features/ui/containers/bundle_container';
import { DatePicker } from 'soapbox/features/ui/util/async-components';
import { useAppSelector, useFeatures } from 'soapbox/hooks';
const messages = defineMessages({
  birthdayPlaceholder: {
    "id": "edit_profile.fields.birthday_placeholder",
    "defaultMessage": "Your birthday"
  },
  previousMonth: {
    "id": "datepicker.previous_month",
    "defaultMessage": "Previous month"
  },
  nextMonth: {
    "id": "datepicker.next_month",
    "defaultMessage": "Next month"
  },
  previousYear: {
    "id": "datepicker.previous_year",
    "defaultMessage": "Previous year"
  },
  nextYear: {
    "id": "datepicker.next_year",
    "defaultMessage": "Next year"
  }
});
const BirthdayInput = ({
  value,
  onChange,
  required
}) => {
  const intl = useIntl();
  const features = useFeatures();
  const supportsBirthdays = features.birthdays;
  const minAge = useAppSelector(state => state.instance.pleroma.getIn(['metadata', 'birthday_min_age']));
  const maxDate = useMemo(() => {
    if (!supportsBirthdays) return null;
    let maxDate = new Date();
    maxDate = new Date(maxDate.getTime() - minAge * 1000 * 60 * 60 * 24 + maxDate.getTimezoneOffset() * 1000 * 60);
    return maxDate;
  }, [minAge]);
  const selected = useMemo(() => {
    if (!supportsBirthdays || !value) return null;
    const date = new Date(value);
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  }, [value]);
  if (!supportsBirthdays) return null;
  const renderCustomHeader = ({
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
    decreaseYear,
    increaseYear,
    prevYearButtonDisabled,
    nextYearButtonDisabled,
    date
  }) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-2",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(IconButton, {
      className: "datepicker__button",
      src: require('@tabler/icons/chevron-left.svg'),
      onClick: decreaseMonth,
      disabled: prevMonthButtonDisabled,
      "aria-label": intl.formatMessage(messages.previousMonth),
      title: intl.formatMessage(messages.previousMonth),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 71,
        columnNumber: 11
      }
    }), intl.formatDate(date, {
      month: 'long'
    }), /*#__PURE__*/React.createElement(IconButton, {
      className: "datepicker__button",
      src: require('@tabler/icons/chevron-right.svg'),
      onClick: increaseMonth,
      disabled: nextMonthButtonDisabled,
      "aria-label": intl.formatMessage(messages.nextMonth),
      title: intl.formatMessage(messages.nextMonth),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 80,
        columnNumber: 11
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 89,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(IconButton, {
      className: "datepicker__button",
      src: require('@tabler/icons/chevron-left.svg'),
      onClick: decreaseYear,
      disabled: prevYearButtonDisabled,
      "aria-label": intl.formatMessage(messages.previousYear),
      title: intl.formatMessage(messages.previousYear),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 90,
        columnNumber: 11
      }
    }), intl.formatDate(date, {
      year: 'numeric'
    }), /*#__PURE__*/React.createElement(IconButton, {
      className: "datepicker__button",
      src: require('@tabler/icons/chevron-right.svg'),
      onClick: increaseYear,
      disabled: nextYearButtonDisabled,
      "aria-label": intl.formatMessage(messages.nextYear),
      title: intl.formatMessage(messages.nextYear),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 99,
        columnNumber: 11
      }
    })));
  };
  const handleChange = date => onChange(date ? new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 10) : '');
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-1 relative rounded-md shadow-sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 115,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: DatePicker,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 116,
      columnNumber: 7
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    selected: selected,
    wrapperClassName: "react-datepicker-wrapper",
    onChange: handleChange,
    placeholderText: intl.formatMessage(messages.birthdayPlaceholder),
    minDate: new Date('1900-01-01'),
    maxDate: maxDate,
    required: required,
    renderCustomHeader: renderCustomHeader,
    isClearable: !required,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 24
    }
  })));
};
export default BirthdayInput;